<template>
  <div>
    <b-row class="match-height">
      <b-col>
        <b-card>
          <template #header>
            <b-icon
              icon="question-square"
              scale="1.5"
              variant="primary"
              class="ml-auto cursor-pointer"
              @click="modal.shortenerIntegrationHelp = true"
            />
          </template>
          <b-form @submit.stop.prevent="save">
            <vue-element-loading :active="loader.form"></vue-element-loading>
            <b-row>
              <b-col>
                <b-form-group label-cols-md="3" label="Shortener">
                  <v-select
                    v-model="shortenerIntegration.shortenerData"
                    :options="parameter.shortenerList"
                    label="provider"
                  />
                </b-form-group>
                <div v-if="shortenerIntegration.shortenerData">
                  <b-form-group
                    v-for="f in shortenerIntegration.shortenerData.fields"
                    :key="f.key"
                    :label="f.isMandatory ? `${f.desc} *` : f.desc"
                    label-cols-md="3"
                  >
                    <b-form-input v-if="f.isMandatory" v-model="f.value" :state="f.value != null && f.value !== ``" />
                    <b-form-input v-else v-model="f.value" />
                  </b-form-group>
                </div>
              </b-col>
            </b-row>
          </b-form>
          <template #footer>
            <b-button variant="success" block @click.stop="save"> Add Shortener </b-button>
          </template>
        </b-card>
      </b-col>
      <b-col col-lg="7">
        <vue-element-loading :active="loader.table"></vue-element-loading>
        <b-card>
          <b-table :items="parsedTableItems" :fields="table.fields" small striped hover>
            <template #cell(data)="data">
              <template v-for="x in data.item.fields">
                <div v-if="x.showInTable" :key="x.key" class="d-flex">
                  <span>{{ x.key }}</span>
                  <span class="ml-auto text-primary"> {{ x.value }}</span>
                </div>
              </template>
            </template>
            <template #cell(action)="data">
              <b-button variant="danger" size="sm" @click.stop="remove(data.item.code)" title="Delete Integration">
                <feather-icon icon="TrashIcon"></feather-icon>
              </b-button>
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import api from "@api";

export default {
  name: `ShortenerIntegration`,
  props: {
    clientCode: {
      type: String,
      required: true,
    },
    slotCode: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      parameter: {
        shortenerList: [
          {
            provider: `T.ly`,
            fields: [
              {
                key: `apiKey`,
                desc: `Api Key`,
                value: null,
                isMandatory: true,
                showInTable: false,
              },
              {
                key: `shortUrl`,
                desc: `Short URL`,
                value: null,
                isMandatory: true,
                showInTable: true,
              },
              {
                key: `path`,
                desc: `Path`,
                value: null,
                isMandatory: false,
                showInTable: true,
              },
            ],
          },
          {
            provider: `Rebrand.ly`,
            fields: [
              {
                key: `apiKey`,
                desc: `Api Key`,
                value: null,
                isMandatory: true,
                showInTable: false,
              },
              {
                key: `shortUrl`,
                desc: `Short URL`,
                value: null,
                isMandatory: true,
                showInTable: true,
              },
              {
                key: `path`,
                desc: `Path`,
                value: null,
                isMandatory: false,
                showInTable: true,
              },
            ],
          },
          {
            provider: `Short.io`,
            fields: [
              {
                key: `apiKey`,
                desc: `Api Key`,
                value: null,
                isMandatory: true,
                showInTable: false,
              },
              {
                key: `domain`,
                desc: `Domain`,
                value: null,
                isMandatory: true,
                showInTable: true,
              },
              {
                key: `shortUrl`,
                desc: `Short URL`,
                value: null,
                isMandatory: true,
                showInTable: true,
              },
              {
                key: `path`,
                desc: `Path`,
                value: null,
                isMandatory: false,
                showInTable: true,
              },
            ],
          },
          {
            provider: `Shlink`,
            fields: [
              {
                key: `apiKey`,
                desc: `Api Key`,
                value: null,
                isMandatory: true,
                showInTable: false,
              },
              {
                key: `apiBaseUrl`,
                desc: `Api Base URL`,
                value: null,
                isMandatory: true,
                showInTable: true,
              },
              {
                key: `domain`,
                desc: `Domain`,
                value: null,
                isMandatory: true,
                showInTable: true,
              },
              {
                key: `slug`,
                desc: `Slug`,
                value: null,
                isMandatory: true,
                showInTable: true,
              },
            ],
          },
        ],
      },
      table: {
        items: [],
        fields: [
          { key: `provider`, label: `Provider` },
          { key: `data`, label: `Data` },
          { key: `action`, label: ``, class: `text-right` },
        ],
      },
      shortenerIntegration: {
        shortenerData: null,
      },
      loader: {
        form: false,
        table: false,
      },
    };
  },
  computed: {
    parsedTableItems() {
      if (this.table.items.length <= 0) return [];
      else
        return this.table.items.map(item => {
          const parsedItem = JSON.parse(item.integrationData);
          parsedItem.code = item.code;
          parsedItem.fields.forEach(x => {
            x.showInTable = this.parameter.shortenerList
              .find(shortener => shortener.provider === parsedItem.provider)
              .fields.filter(fieldParam => fieldParam.key === x.key)[0].showInTable;
          });

          return parsedItem;
        });
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.loader.table = true;
      try {
        this.table.items = await api.get(`slot/integration/shortener/${this.slotCode}`);
      } catch (error) {
        this.showToast(`error`, error);
      } finally {
        this.loader.table = false;
      }
    },

    async validateShortener() {
      try {
        console.log(this.shortenerIntegration.shortenerData);
        var result = await api.post(`integration/validation/shortener`, this.shortenerIntegration.shortenerData);
        return result;
      } catch (error) {
        this.showToast(`error`, error);
        return false;
      }
    },

    async save() {
      this.loader.form = true;

      try {
        let validCred = await this.validateShortener();

        if (!validCred) {
          this.showToast(`error`, `Shortener Credential Data is not valid`);
          return;
        }

        await api.post(`slot/integration/shortener`, {
          slotCode: this.slotCode,
          shortenerData: { ...this.shortenerIntegration.shortenerData },
        });

        this.showToast(`success`, `Shortener Integration Saved Successfully`);
        this.shortenerIntegration.shortenerData = null;
        this.loadData();
      } catch (error) {
        this.showToast(`error`, error);
      } finally {
        this.loader.form = false;
      }
    },

    safeJsonParse(jsonString) {
      try {
        return JSON.parse(jsonString);
      } catch (error) {
        console.error("Error parsing JSON:", error);
        return null;
      }
    },
    async remove(code) {
      let isConfirmed = await this.showConfirm(`Are you sure you want to delete this shortener integration?`);
      if (!isConfirmed) return;
      this.loader.table = true;
      try {
        await api.delete(`slot/integration/shortener/${code}`);
        this.showToast(`success`, `Shortener Integration Deleted Successfully`);

        await this.loadData();
      } catch (error) {
        this.showToast(`error`, error);
      } finally {
        this.loader.table = false;
      }
    },
  },
};
</script>
